var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedInCircle = function SvgLinkedInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedIn-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.143,
    cy: 12,
    r: 12,
    fill: "#0A66C2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.2,
    height: 16.723,
    x: 4.344,
    y: 3.213,
    fill: "#fff",
    rx: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A66C2",
    d: "M18.147 17.462h-2.4v-3.88c0-.926-.016-2.117-1.249-2.117-1.25 0-1.441 1.008-1.441 2.05v3.947h-2.4v-7.98h2.304v1.09h.032c.23-.406.564-.741.964-.968s.853-.338 1.31-.32c2.432 0 2.88 1.651 2.88 3.8zM7.948 8.392c-.276 0-.545-.085-.774-.243a1.43 1.43 0 0 1-.513-.645 1.5 1.5 0 0 1-.08-.83c.054-.28.187-.536.382-.737a1.4 1.4 0 0 1 .713-.394c.27-.055.55-.027.805.082.254.109.472.293.625.53a1.47 1.47 0 0 1-.173 1.815 1.4 1.4 0 0 1-.452.312c-.169.072-.35.11-.533.11m1.2 9.07H6.745v-7.98h2.403zM19.344 3.214H5.539a1.16 1.16 0 0 0-.84.348 1.24 1.24 0 0 0-.355.858v14.31c.003.323.131.631.356.858s.526.351.84.348h13.804c.314.004.616-.121.841-.347.226-.226.354-.536.359-.86V4.42a1.24 1.24 0 0 0-.359-.86 1.17 1.17 0 0 0-.841-.346"
  }))));
};
export { SvgLinkedInCircle as ReactComponent };